import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AdminProvider, useAdmin } from './context/AdminContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Expertise from './pages/Expertise';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { Toaster } from './components/ui/sonner';

const RequireAdmin = ({ children }) => {
  const { isAuth, checking } = useAdmin();
  if (checking) {
    return (
      <div className="min-h-screen bg-[#1b2331] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#c8a469] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return isAuth ? children : <Navigate to="/admin/login" replace />;
};

const Layout = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/biens" element={<Properties />} />
          <Route path="/bien/:id" element={<PropertyDetail />} />
          <Route path="/expertises" element={<Expertise />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AdminProvider>
          <BrowserRouter>
            <Layout />
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </AdminProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
